import { useEffect } from "react";
import { branding, organization } from "../../config";
import RentFormPublic from "../../components/public/RentFormPublic";

export default function RentPublic() {
  useEffect(() => {
    document.title = `Pay Rent - ${organization.name}`;
  }, []);

  return (
    <>
      <RentFormPublic/>
    </>
  );
}
